// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3Tgl9{display:-ms-flexbox;display:flex;width:100%;-ms-flex-pack:center;justify-content:center}.GDXFi{font-weight:700;max-width:450px;padding:16px;width:100%}._2FH5o{color:#6f7ea2;margin-bottom:1.6rem}html[dir=ltr] ._2FH5o{text-align:right}html[dir=rtl] ._2FH5o{text-align:left}._2FH5o>span{color:#0a385a}._34RZo{margin-bottom:1.6rem}._2Pjx7{margin-top:1.6rem}._34RZo,._2Pjx7{color:#6f7ea2;font-size:12px;font-size:1.2rem}html[dir=ltr] ._34RZo,html[dir=ltr] ._2Pjx7{text-align:right}html[dir=rtl] ._34RZo,html[dir=rtl] ._2Pjx7{text-align:left}", ""]);
// Exports
exports.locals = {
	"container": "_3Tgl9",
	"content": "GDXFi",
	"summary": "_2FH5o",
	"cgmBeneficial": "_34RZo",
	"cgmTimePercentage": "_2Pjx7"
};
module.exports = exports;
